"use strict";

exports.__esModule = true;
exports.ElementTree = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _common = require("../../common");
var _ElementTreeLabel = require("./ElementTreeLabel");
var _ElementEditorContextMenu = require("../ElementEditorContextMenu");
var _ElementEditorContext = require("../ElementEditorContext");
var _excluded = ["rootElement", "selectedPath", "widgets", "onSelect", "elementEditor", "intl"];
var _dec, _class, _ElementTree;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Shows the hierarchy of a layout element in a tree.
 */
var ElementTree = exports.ElementTree = (_dec = _ElementEditorContext.ElementEditorContext.withContext, (0, _reactIntl.injectIntl)(_class = _dec(_class = (_ElementTree = /*#__PURE__*/function (_Component) {
  function ElementTree() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      expandedIds: []
    };
    _this.handleNodeClick = function (_ref) {
      var elementPath = _ref.elementPath;
      var onSelect = _this.props.onSelect;
      onSelect(elementPath);
    };
    _this.handleNodeExpand = function (_ref2) {
      var id = _ref2.id,
        elementPath = _ref2.elementPath;
      var onSelect = _this.props.onSelect;
      _this.setState(function (prevState) {
        return {
          expandedIds: prevState.expandedIds.concat(id)
        };
      });
      onSelect(elementPath);
    };
    _this.handleNodeCollapse = function (_ref3) {
      var id = _ref3.id,
        elementPath = _ref3.elementPath;
      var onSelect = _this.props.onSelect;
      _this.setState(function (prevState) {
        return {
          expandedIds: prevState.expandedIds.filter(function (item) {
            return item !== id;
          })
        };
      });
      if (elementPath.length > 2) {
        onSelect(elementPath.slice(0, elementPath.length - 2));
      } else {
        onSelect([]);
      }
    };
    _this.handleNodeContextMenu = function (node, nodePath, e) {
      e.preventDefault();
      var _this$props = _this.props,
        elementEditor = _this$props.elementEditor,
        intl = _this$props.intl;
      var menu = /*#__PURE__*/_react["default"].createElement(_ElementEditorContextMenu.ElementEditorContextMenu, {
        path: node.elementPath,
        elementEditor: elementEditor,
        intl: intl
      });
      (0, _core.showContextMenu)({
        content: menu,
        targetOffset: {
          left: e.clientX,
          top: e.clientY
        }
      });
    };
    return _this;
  }
  _inheritsLoose(ElementTree, _Component);
  var _proto = ElementTree.prototype;
  _proto.getTreeContents = function getTreeContents() {
    return [this.layoutElementToTree(this.props.rootElement, [])];
  };
  _proto.layoutElementToTree = function layoutElementToTree(element, path) {
    var _this2 = this;
    var _this$props2 = this.props,
      selectedPath = _this$props2.selectedPath,
      widgets = _this$props2.widgets;
    var expandedIds = this.state.expandedIds;
    var id = path.join("/");
    var widget = (0, _common.getWidget)(widgets, element.type);
    var label = /*#__PURE__*/_react["default"].createElement(_ElementTreeLabel.ElementTreeLabel, {
      widget: widget,
      path: path,
      element: element
    });
    var childNodes = element.children.map(function (child, index) {
      return _this2.layoutElementToTree(child, path.concat("children", index));
    });
    var icon = widget ? widget.icon : undefined;
    var isExpanded = expandedIds.includes(id) || (0, _common.getPathContainsPath)(path, selectedPath);
    var isSelected = (0, _common.compareElementPaths)(path, selectedPath) === 0;
    var hasCaret = element.children.length > 0;
    return {
      id: id,
      // Blueprint's Tree overwrites a node's `path` prop with its own numeric
      // index path before handing the node back to our handlers, so the element
      // path travels under a key Blueprint leaves alone.
      elementPath: path,
      label: label,
      childNodes: childNodes,
      icon: icon,
      isExpanded: isExpanded,
      isSelected: isSelected,
      hasCaret: hasCaret
    };
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      rootElement = _this$props3.rootElement,
      selectedPath = _this$props3.selectedPath,
      widgets = _this$props3.widgets,
      onSelect = _this$props3.onSelect,
      elementEditor = _this$props3.elementEditor,
      intl = _this$props3.intl,
      extra = _objectWithoutPropertiesLoose(_this$props3, _excluded);
    return /*#__PURE__*/_react["default"].createElement("div", extra, /*#__PURE__*/_react["default"].createElement(_core.Tree, {
      contents: this.getTreeContents(),
      onNodeClick: this.handleNodeClick,
      onNodeExpand: this.handleNodeExpand,
      onNodeCollapse: this.handleNodeCollapse,
      onNodeContextMenu: this.handleNodeContextMenu
    }));
  };
  return ElementTree;
}(_react.Component), _ElementTree.defaultProps = {
  elementEditor: undefined
}, _ElementTree)) || _class) || _class);